(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dw-product-template-compatible-products"] && !Shopify.designMode) return;
  try {
    // A variant change puts in the block of the new variant (renderProductInfo in template-product.js), and a colour of another product puts in the
  // whole section: the listeners are on the document and look the elements up each time
  const compatibleParts = () => {
    const productsContainer = document.getElementById('compatible-products-list')
    const showingProducts = !!productsContainer && !productsContainer.hidden
    const filterStrapsSelect = document.getElementById('compatible-filter-straps-select')
    const filterJewellerySelect = document.getElementById('compatible-filter-jewellery-select')
    return {
      loadMoreButton: document.getElementById('compatible-load-more'),
      showLessButton: document.getElementById('compatible-show-less'),
      filterStrapsSelect,
      filterJewellerySelect,
      strapsBtn: document.getElementById('compatible-toggle-straps'),
      jewelleryBtn: document.getElementById('compatible-toggle-jewellery'),
      productsContainer,
      jewelleryContainer: document.getElementById('compatible-jewellery-list'),
      activeScope: showingProducts ? '#compatible-products-list' : '#compatible-jewellery-list',
      activeFilter: showingProducts ? filterStrapsSelect : filterJewellerySelect
    }
  }

  const applyFilter = (toLoad) => {
    const { loadMoreButton, showLessButton, activeScope, activeFilter } = compatibleParts()
    if (!toLoad) {
      toLoad = loadMoreButton ? parseInt(loadMoreButton.dataset.loadMore) : Infinity
    }
    if (!activeFilter) return
    const val = (activeFilter.value || '').toLowerCase()

    const cards = document.querySelectorAll(`${activeScope} compatible-card`)

    let showCount = 0
    let filteredCount = 0
    cards.forEach(card => {
      const type = (card.dataset.productType || '').toLowerCase()
      if (!val || val === '' || type === val) {
        filteredCount++
        if(loadMoreButton && showCount >= toLoad) {
          card.hidden = true
          return
        }
        card.hidden = false
        showCount++
      } else {
        card.hidden = true
      }
    })

    if (loadMoreButton) {
      loadMoreButton.hidden = showCount >= filteredCount
    }

    if (showLessButton) {
      showLessButton.hidden = toLoad <= parseInt(showLessButton.dataset.loadMore)
    }
  }

  const setActiveTab = (target) => {
    const { filterStrapsSelect, filterJewellerySelect, strapsBtn, jewelleryBtn, productsContainer, jewelleryContainer } = compatibleParts()
    const showProducts = target === 'products'
    if (productsContainer) productsContainer.hidden = !showProducts
    if (jewelleryContainer) jewelleryContainer.hidden = showProducts
    if (strapsBtn) strapsBtn.classList.toggle('is-active', showProducts)
    if (jewelleryBtn) jewelleryBtn.classList.toggle('is-active', !showProducts)
    if (filterJewellerySelect) filterJewellerySelect.classList.toggle('hidden', showProducts)
    if (filterStrapsSelect) filterStrapsSelect.classList.toggle('hidden', !showProducts)
    applyFilter()
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return
    const tab = event.target.closest('#compatible-toggle-straps, #compatible-toggle-jewellery')
    if (tab) {
      setActiveTab(tab.id === 'compatible-toggle-straps' ? 'products' : 'jewellery')
      return
    }
    const loadMoreButton = event.target.closest('#compatible-load-more')
    if (loadMoreButton) {
      const { activeScope } = compatibleParts()
      const hiddenCards = document.querySelectorAll(`${activeScope} compatible-card[hidden]`)
      const totalCards = document.querySelectorAll(`${activeScope} compatible-card`).length
      applyFilter(totalCards - hiddenCards.length + parseInt(loadMoreButton.dataset.loadMore))
      return
    }
    const showLessButton = event.target.closest('#compatible-show-less')
    if (showLessButton) {
      const { activeScope } = compatibleParts()
      const hiddenCards = document.querySelectorAll(`${activeScope} compatible-card[hidden]`)
      const totalCards = document.querySelectorAll(`${activeScope} compatible-card`).length
      const step = parseInt(showLessButton.dataset.loadMore)
      applyFilter(Math.max(totalCards - hiddenCards.length - step, step))
    }
  })

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return
    if (event.target.matches('#compatible-filter-straps-select, #compatible-filter-jewellery-select')) applyFilter()
    // the offer price of the size that is chosen in a card
    if (event.target.matches('compatible-card .compatible-variant-selector select')) {
      event.target.closest('compatible-card').querySelectorAll('[data-compatible-price-variant]').forEach((price) => {
        price.hidden = price.dataset.compatiblePriceVariant !== event.target.value
      })
    }
  })
  } catch(e) { console.error(e); }
})();

})();
